// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"505":"2b1f31f9","594":"c7fcbfc8"}[chunkId] + ".css";
};